module.exports = __webpack_public_path__ + "static/media/XLH_Carousel.9d3d584d.jpg";